export const parcelsEs = {
  parcels: {
    title: "Mis Parcelas",
    subtitle: "Gestiona y monitorea todas tus parcelas agrícolas",
    addParcel: "Añadir Parcela",
    editParcel: "Editar Parcela",
    deleteParcel: "Eliminar Parcela",
    parcelName: "Nombre de Parcela",
    cropType: "Tipo de Cultivo",
    area: "Superficie",
    location: "Ubicación",
    status: "Estado",
    lastAnalysis: "Último Análisis",
    ndviValue: "Valor NDVI",
    irrigationStatus: "Estado de Riego",
    healthStatus: "Estado de Salud",
    healthy: "Saludable",
    warning: "Advertencia",
    critical: "Crítico",
    viewDetails: "Ver Detalles",
    noParcel: "No se encontraron parcelas",
    addFirstParcel: "Añade tu primera parcela para comenzar",
    coordinates: "Coordenadas",
    plantingDate: "Fecha de Siembra",
    expectedHarvest: "Cosecha Esperada",
    soilType: "Tipo de Suelo"
  },
  parcelsPage: {
    title: "Mis Parcelas",
    titleUrban: "Mis Espacios Verdes",
    subtitle: "Gestiona y monitorea tus parcelas agrícolas",
    subtitleUrban: "Gestiona y monitorea tus espacios verdes urbanos",
    addButton: "Añadir Parcela",
    addButtonUrban: "Añadir Espacio Verde",
    addFirst: "Añade Tu Primera Parcela",
    addFirstUrban: "Añade Tu Primer Espacio Verde",
    emptyTitle: "Sin Parcelas Añadidas",
    emptyTitleUrban: "Sin Espacios Verdes Añadidos",
    emptyDesc: "Comienza añadiendo tu primera parcela agrícola para empezar el monitoreo con imágenes satelitales y análisis meteorológico.",
    emptyDescUrban: "Comienza añadiendo tu primer espacio verde urbano para empezar el monitoreo con imágenes satelitales y análisis ambiental.",
    overview: "Resumen",
    map: "Mapa",
    weather: "Clima",
    analytics: "Análisis",
    soil: "Suelo",
    policies: "Pólizas",
    drought: "Sequía",
    riskAssessment: "Evaluación de Riesgo",
    ndviHealth: "Salud NDVI",
    waterStress: "Estrés Hídrico",
    temperature: "Temperatura",
    humidity: "Humedad",
    precipitation: "Precipitación",
    windSpeed: "Velocidad del Viento",
    analyze: "Analizar",
    analyzing: "Analizando...",
    analysisCompleted: "Análisis Completado",
    analysisDesc: "Evaluación de riesgo y datos satelitales actualizados correctamente",
    deleteParcel: "Eliminar",
    deleteConfirm: "¿Estás seguro de que quieres eliminar esta parcela? Esto también eliminará todos los análisis y alertas relacionados.",
    parcelDeleted: "Parcela Eliminada",
    parcelDeletedDesc: "La parcela y todos los datos relacionados se han eliminado correctamente.",
    highRisk: "Riesgo alto detectado",
    moderateRisk: "Riesgo moderado",
    lowRiskConditions: "Condiciones de bajo riesgo",
    excellentVeg: "Salud vegetal excelente",
    goodVeg: "Buena salud vegetal",
    fairVeg: "Salud vegetal aceptable",
    poorVeg: "Salud vegetal deficiente",
    adequateWater: "Contenido de agua adecuado",
    moderateWaterStress: "Estrés hídrico moderado",
    highWaterStress: "Estrés hídrico alto",
    weatherCard: {
      tempCurrent: "Actual",
      tempMean: "Media",
      tempMeanLabel: "Temperatura media",
      tempTooltip: "Temperatura media actual registrada por la estación meteorológica más cercana.",
      humidityLabel: "Humedad relativa (último día)",
      humidityTooltip: "Humedad relativa media del aire (%) — última observación diaria disponible. Fuente: AEMET (España) u Open-Meteo ERA5. Si aparece \"—\" significa que la fuente no reportó dato.",
      precipLabel: "Precipitación (último día observado)",
      precipNone: "Sin lluvia en el último día",
      precipRecorded: "Lluvia registrada",
      precipNoData: "Sin datos",
      precipTooltip: "Precipitación reportada en la última observación diaria (mm) en la estación o pixel ERA5 más cercano. No representa el acumulado de los últimos 7 días — para histórico ver la tabla \"Last 7 Days\" más abajo. Si la fuente no reporta dato aparecerá \"—\".",
      windLabel: "Velocidad del viento",
      windTooltip: "Velocidad media del viento (km/h). Puede no estar disponible con todas las fuentes de datos.",
      sourceAemetTooltip: "Datos oficiales de AEMET (Agencia Estatal de Meteorología)",
      sourceOpenMeteoTooltip: "Datos de Open-Meteo ERA5 (reanálisis satelital de alta calidad)"
    }
  }
};
